<template>
  <div class="menu-wrap">
    <input type="checkbox" class="toggler" v-model="check" />
    <div class="hamburger"><div></div></div>
    <div class="menu">
      <div>
        <div>
          <ul>
            <li>
              <a @click="click()"
                ><router-link to="/"> {{ this.contents.find(content => content.id_content === 176)?.title }} </router-link></a
              >
            </li>
            <li>
              <a @click="click()">
                <router-link to="/services">{{ this.contents.find(content => content.id_content === 166)?.title }}</router-link></a
              >
            </li>
            <li>
              <a @click="click()">
                <router-link to="/about">{{ this.contents.find(content => content.id_content === 167)?.title }}</router-link></a
              >
            </li>
            <li>
              <a @click="click()">
                <router-link to="/carrers">{{ this.contents.find(content => content.id_content === 168)?.title }}</router-link></a
              >
            </li>
            <li>
              <a @click="click()">
                <router-link to="/contacts">{{ this.contents.find(content => content.id_content === 169)?.title }}</router-link></a
              >
            </li>
            <li>
              <div class="language-switcher">
                <select v-model="language" @change="changeLanguage" class="lang-select">
                  <option value="pt">🇵🇹 Português</option>
                  <option value="en">🇬🇧 English</option>
                </select>
              </div>
            </li>
            <li>
              <a><img src="../assets/linkedin.svg" id="link" alt=""/></a>
              <a><img src="../assets/facebook.svg" id="link" alt=""/></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* import func from "vue-editor-bridge"; */
/* import { Slide } from "vue-burger-menu";*/

import {mapGetters} from "vuex";

export default {
  data: function () {
    return {
      check: "",
      contents: [],
      language: "pt"
    };
  },
  mounted() {
    this.getAllContent();

    const savedLang = localStorage.getItem("lang");
    if (savedLang) {
      this.language = savedLang;
    }

  },
  methods: {
    click() {
      this.check = false;
    },
    async getAllContent() {
      this.contents = [];
      try {
        await this.$store.dispatch("fetchContent");
        let lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : this.language;
        for (let i = 0; i < this.getContent.data.length; i++) {
          if (this.getContent.data[i].page == 7) {
            let content = {
              id_content: this.getContent.data[i].id_content,
              title: lang === "pt" ? this.getContent.data[i].title : this.getContent.data[i].title_en,
              description: lang === "pt" ? this.getContent.data[i].description : this.getContent.data[i].description_en,
              img: this.img,
            };
            this.contents.push(content);
          }
        }
      } catch (err) {
        this.$router.push({name: "Error"});
      }
    },
    changeLanguage() {
      localStorage.setItem("lang", this.language);
      this.$emit("change-language", this.language);
      window.location.reload();
    }
  },
  computed: {
    ...mapGetters(["getContent"]),
    activeColor() {
      return {dark: !!this.$route.meta?.mode};
    },
  },
};
</script>

<style>
:root {
  --overlay-color: rgba(247, 148, 30);
  --menu-speed: 0.75s;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  max-width: 960px;
  margin: auto;
  overflow: hidden;
  padding: 0 3rem;
}
a {
  padding-bottom: 20px;
  text-align: center;
  font-family: "Barlow", sans-serif;
  font-weight: 500;
}
a:hover {
  color: #888888;
  text-decoration: none;
}
/* MENU STYLES */
.menu-wrap {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
}

.menu-wrap .toggler {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  cursor: pointer;
  width: 50px;
  height: 50px;
  opacity: 0;
}

.menu-wrap .hamburger {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 60px;
  height: 60px;
  padding: 1rem;
  background: var(--primary-color);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Hamburger Line */
.menu-wrap .hamburger > div {
  position: relative;
  flex: none;
  width: 100%;
  height: 2px;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s ease;
}

/* Hamburger Lines - Top & Bottom */
.menu-wrap .hamburger > div::before,
.menu-wrap .hamburger > div::after {
  content: "";
  position: absolute;
  z-index: 1;
  top: -10px;
  width: 100%;
  height: 2px;
  background: inherit;
}

/* Moves Line Down */
.menu-wrap .hamburger > div::after {
  top: 10px;
}

/* Toggler Animation */
.menu-wrap .toggler:checked + .hamburger > div {
  transform: rotate(135deg);
}

/* Turns Lines Into X */
.menu-wrap .toggler:checked + .hamburger > div:before,
.menu-wrap .toggler:checked + .hamburger > div:after {
  top: 0;
  transform: rotate(90deg);
}

/* Rotate On Hover When Checked */
.menu-wrap .toggler:checked:hover + .hamburger > div {
  transform: rotate(225deg);
}

/* Show Menu */
.menu-wrap .toggler:checked ~ .menu {
  visibility: visible;
}

.menu-wrap .toggler:checked ~ .menu > div {
  transform: scale(1);
  transition-duration: var(--menu-speed);
}

.menu-wrap .toggler:checked ~ .menu > div > div {
  opacity: 1;
  transition: opacity 0.4s ease 0.4s;
}

/* .menu-wrap .toggler:checked ~ .menu a:focus {
  visibility: collapse;
}
 */
.menu-wrap .menu {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  visibility: hidden;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-wrap .menu > div {
  background: var(--overlay-color);
  border-radius: 50%;
  width: 200vw;
  height: 200vw;
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  transform: scale(0);
  transition: all 0.4s ease;
}

.menu-wrap .menu > div > div {
  text-align: center;
  max-width: 90vw;
  max-height: 100vh;
  opacity: 0;
  transition: opacity 0.4s ease;
}

.menu-wrap .menu > div > div > ul > li {
  list-style: none;
  color: #fff;
  font-size: 38px;
  padding: 1rem;
}

.menu-wrap .menu > div > div > ul > li > router-link {
  color: inherit;
  text-decoration: none;
  transition: color 0.4s ease;
}
#link {
  height: 40px;
  margin-left: 20px;
  margin-right: 20px;
}
.menu li {
  color: white;
}
.menu li:focus ~ .menu {
  visibility: collapse;
}
a {
  color: #fff;
  text-decoration: none;
}
a:focus {
  color: #fff;
}
.language-switcher {
  margin-left: auto;
}

.lang-select {
  background: white;
  border: 1px solid #f7941e;
  padding: 5px 12px;
  font-weight: 400;
  font-size: 17px;
  color: #333;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 8px;
}

.lang-select:hover {
  background: #f7941e;
  color: white;
}
</style>
